var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1751_41012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1751_41012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 8.49997C4.0263 8.49997 3.90755 8.45203 3.81172 8.35617C3.71589 8.26029 3.66797 8.14149 3.66797 7.99977C3.66797 7.85803 3.71589 7.73931 3.81172 7.64358C3.90755 7.54786 4.0263 7.5 4.16797 7.5H11.8346C11.9763 7.5 12.095 7.54793 12.1909 7.6438C12.2867 7.73968 12.3346 7.85848 12.3346 8.0002C12.3346 8.14193 12.2867 8.26066 12.1909 8.35638C12.095 8.45211 11.9763 8.49997 11.8346 8.49997H4.16797Z",
    fill: "#0360D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c104a0cb3f70165a16b0054ab15ccafb.svg";
export { ForwardRef as ReactComponent };